<template>
  <div
    class="wheel-picker relative overflow-hidden select-none"
    :style="{ height: containerHeight + 'px' }"
  >
    <!-- Градиенты сверху и снизу -->
    <div class="absolute inset-x-0 top-0 z-10 pointer-events-none" :style="{ height: itemH * 2 + 'px', background: 'linear-gradient(to bottom, #FAF3E8, transparent)' }" />
    <div class="absolute inset-x-0 bottom-0 z-10 pointer-events-none" :style="{ height: itemH * 2 + 'px', background: 'linear-gradient(to top, #FAF3E8, transparent)' }" />

    <!-- Выделение центра -->
    <div
      class="absolute inset-x-0 z-[5] pointer-events-none rounded-xl"
      :style="{ top: itemH * 2 + 'px', height: itemH + 'px', background: 'rgba(65,41,26,0.06)' }"
    />

    <!-- Скролл -->
    <div
      ref="scrollRef"
      class="h-full overflow-y-auto scrollbar-hide"
      style="scroll-snap-type: y mandatory; -webkit-overflow-scrolling: touch;"
      @scroll="onScroll"
    >
      <!-- Пустые элементы сверху (2 шт для центрирования) -->
      <div :style="{ height: itemH * 2 + 'px' }" />

      <div
        v-for="(item, i) in items"
        :key="i"
        class="flex items-center justify-center transition-all duration-100"
        style="scroll-snap-align: center;"
        :style="{
          height: itemH + 'px',
          fontSize: i === activeIndex ? '28px' : '18px',
          fontWeight: i === activeIndex ? '700' : '400',
          color: '#41291A',
          opacity: i === activeIndex ? 1 : Math.max(0.15, 1 - Math.abs(i - activeIndex) * 0.3),
        }"
      >
        {{ item }}
      </div>

      <!-- Пустые элементы снизу -->
      <div :style="{ height: itemH * 2 + 'px' }" />
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted, nextTick } from 'vue'

const props = defineProps({
  items:      { type: Array, required: true },
  modelValue: { type: [String, Number], default: null },
})

const emit = defineEmits(['update:modelValue'])

const itemH = 48
const containerHeight = itemH * 5

const scrollRef = ref(null)
const activeIndex = ref(0)
let scrollTimer = null

function getIndexForValue(val) {
  const idx = props.items.indexOf(val)
  return idx >= 0 ? idx : 0
}

function scrollToIndex(idx, smooth = false) {
  if (!scrollRef.value) return
  const top = idx * itemH
  scrollRef.value.scrollTo({ top, behavior: smooth ? 'smooth' : 'instant' })
}

function onScroll() {
  if (!scrollRef.value) return
  const top = scrollRef.value.scrollTop
  const idx = Math.round(top / itemH)
  const clamped = Math.max(0, Math.min(idx, props.items.length - 1))
  activeIndex.value = clamped

  clearTimeout(scrollTimer)
  scrollTimer = setTimeout(() => {
    // Snap to nearest
    scrollToIndex(clamped, true)
    if (props.items[clamped] !== props.modelValue) {
      emit('update:modelValue', props.items[clamped])
    }
  }, 80)
}

watch(() => props.modelValue, (val) => {
  const idx = getIndexForValue(val)
  if (idx !== activeIndex.value) {
    activeIndex.value = idx
    scrollToIndex(idx)
  }
})

onMounted(() => {
  nextTick(() => {
    const idx = getIndexForValue(props.modelValue)
    activeIndex.value = idx
    scrollToIndex(idx)
  })
})
</script>

<style scoped>
.scrollbar-hide { scrollbar-width: none; }
.scrollbar-hide::-webkit-scrollbar { display: none; }
</style>
